<template>
	<div class="main">
		<div class="menu">
			<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
				background-color="rgb(250, 250, 250)">
				<el-menu-item index="1">备货建议</el-menu-item>
			</el-menu>
		</div>
		<div class="select_menu">
			<!-- <el-input v-model="input" placeholder="搜索标题和id" style="width: 10%;"></el-input> -->
			<el-input v-model="query" placeholder="请输入父体名称" style="width: 200px; margin-left: 10px;"></el-input>
			<el-select v-model="filterText" placeholder="请选择店铺" style="margin-left: 10px;width:130px">
				<el-option v-for="item in filters" :key="item.value" :label="item.text" :value="item.value">
				</el-option>
			</el-select>
			<el-button style="margin-left: 10px;" @click="init" :loading="isSending">获取本地父体</el-button>

			<el-button style="margin-left: 20px;" @click="check_care_parent"
				:loading="isSending_parent">获取本地收藏父体</el-button>

			<span class="input-label">本地品名:</span>
			<el-input placeholder="请输入本地品名" prefix-icon="el-icon-search" v-model="select_input"
				style="margin-left: 35px;width: 13%;">
			</el-input>
			<span class="input-label">SKU:</span>
			<el-input placeholder="请输入sku" prefix-icon="el-icon-search" v-model="select_input2"
				style="margin-left: 35px;width: 13%;">
			</el-input>
			<el-button style="margin-left: 5px;" @click="select_pm" :loading="isSending8">搜索</el-button>



		</div>
		<div class="parent_calculate">
			<el-button style="float: right;margin-top: -15px;margin-right: 10px;" @click="allupdate">批量编辑</el-button>
			<el-button style="float: right;margin-top: -15px;margin-right: 10px;" @click="jojo2"
				:loading="isSending18">一键采购</el-button>
			<el-button slot="reference" style="float: right;margin-top: -15px;margin-right: 10px;" @click="change_all"
				:loading="isSending18">建议置换指定数量</el-button>
			<div class="parent_calculate_div1">
				<div class="parent_calculate_table1">
					<el-table :data="tableData" style="width: 100%" :show-header="false" height="100%" size>
						<el-table-column width="15">
						</el-table-column>
						<el-table-column prop="本地父体" label="本地父体">
							<template slot-scope="scope">
								<div slot="reference" class="name-wrapper" @click="jojo(scope.row.本地父体)"
									v-if="scope.row.是否收藏 == '否'">
									<span v-if="scope.row.是否收藏 == '否'">
										{{ scope.row.本地父体 }}
										<el-button type="text" size="mini" icon="el-icon-star-off"
											@click.stop="open(scope.row.本地父体)">
											收藏
										</el-button>
									</span>




								</div>
								<div slot="reference" class="name-wrapper" @click="jojo(scope.row.本地父体)"
									v-if="scope.row.是否收藏 == '是'">
									<span v-if="scope.row.是否收藏 == '是'">
										{{ scope.row.本地父体 }}
										<el-button type="text" size="mini" icon="el-icon-star-on"
											@click.stop="open1(scope.row.本地父体)">
											取消收藏
										</el-button>
									</span>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="parent_calculate_div1">
				<div class="parent_calculate_table2">
					<el-table :data="tableData1" style="width: 580%" height="100%" border
						@cell-dblclick="doubleClickCell" :row-style="getRowStyle">
						<el-table-column type="expand">
							<template slot-scope="scope">
								<el-form label-position="left" inline class="demo-table-expand">
									<el-form-item label="会员日备货">
										<span>{{ scope.row.会员日备货 }}</span>
									</el-form-item>
									<el-form-item label="黑五备货">
										<span>{{ scope.row.黑五备货 }}</span>
									</el-form-item>
									<el-form-item label="旺季备货">
										<span>{{ scope.row.旺季备货 }}</span>
									</el-form-item>
								</el-form>
							</template>
						</el-table-column>
						<el-table-column prop="本地父体" label="本地父体" width="168">
							<template slot-scope="scope">
								{{ scope.row.本地父体 }}
							</template>
						</el-table-column>
						<el-table-column prop="本地品名" label="本地品名" width="168">
							<template slot-scope="scope">
								<div slot="reference" class="name-wrapper" style="padding-top: 5px;">
									{{ scope.row.本地品名 }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="FBA库存" label="FBA库存" width="100">
							<template slot-scope="scope">
								<div slot="reference" class="name-wrapper" style="padding-top: 5px;">
									{{ scope.row.FBA库存 }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="FBA在途" label="FBA在途" width="100">
							<template slot-scope="scope">
								<div slot="reference" class="name-wrapper" style="padding-top: 5px;">
									{{ scope.row.FBA在途 }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="本地库存" label="本地库存" width="105" sortable>
							<template slot-scope="scope">
								<div slot="reference" class="name-wrapper" style="padding-top: 5px;">
									{{ scope.row.本地库存 }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="采购在途" label="采购在途" width="100">
							<template slot-scope="scope">
								<div slot="reference" class="name-wrapper" style="padding-top: 5px;">
									{{ scope.row.预计库存 - scope.row.本地库存 }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="预计库存" label="预计库存" width="100">
							<template slot-scope="scope">
								<div slot="reference" class="name-wrapper" style="padding-top: 5px;">
									{{ scope.row.预计库存 }}
								</div>
							</template>
						</el-table-column>
						<el-table-column label="销量数据" width="120" sortable prop="mergedSales"
							:sort-method="sortBy30Days">
							<template slot-scope="scope">
								<div class="sales-wrapper">
									<div class="sales-item" slot="reference">30天销量: {{ scope.row.三十天销量 }}</div>
									<div class="sales-item" slot="reference">14天销量: {{ scope.row.十四天销量 }}</div>
									<div class="sales-item" slot="reference">7天销量: {{ scope.row.七天销量 }}</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="安全天数" label="安全天数" width="110">
							<template slot-scope="scope">
								<div slot="reference" class="name-wrapper" :style="{
									'padding-top': '5px',
									'background-color': calculateSafetyStock(scope.row) < 70 ? 'yellow' : ''
								}">
									{{ calculateSafetyStock(scope.row) }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="sku" label="sku" width="100">
							<template slot-scope="scope">
								<div slot="reference" class="name-wrapper" style="padding-top: 5px;">
									{{ scope.row.sku }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="fnsku" label="fnsku" width="100">
							<template slot-scope="scope">
								<div slot="reference" class="name-wrapper" style="padding-top: 5px;">
									{{ scope.row.fnsku }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="每个ASIN采购数量" label="每个ASIN采购数量" width="100">
							<template slot-scope="scope">
								<div slot="reference" class="name-wrapper" style="padding-top: 5px;">
									{{ scope.row.每个ASIN采购数量 }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="MSKU模版" label="MSKU模版" width="100">
							<template slot-scope="scope">
								<div slot="reference" class="name-wrapper" style="padding-top: 5px;">
									{{ scope.row.MSKU模版 }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="供应商" label="供应商" width="100">
							<template slot-scope="scope">
								<div slot="reference" class="name-wrapper" style="padding-top: 5px;">
									{{ scope.row.供应商 }}
								</div>
							</template>
						</el-table-column>
						<el-table-column fixed="right" label="采购数量" width="130">
							<template slot-scope="scope">
								<div class="purchase-wrapper">
									<div class="purchase-item">
										<span class="label">待采购:</span>
										<span class="value">{{ scope.row.预采购数量 }}</span>
									</div>
									<div class="purchase-item">
										<span class="label">已采购:</span>
										<span class="value">{{ scope.row.已采购数量 }}</span>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column fixed="right" prop="指定采购数量" label="指定采购数量" width="130" sortable>
							<template slot-scope="scope">
								<div v-if="!scope.row.edit" slot="reference" class="name-wrapper"
									style="padding-top: 5px;">
									{{ scope.row.指定采购数量 }}
								</div>
								<el-input v-else v-model="scope.row.指定采购数量" @blur="levelChange(scope.row)">
									{{ scope.row.指定采购数量 }}
								</el-input>
							</template>
						</el-table-column>
						<el-table-column fixed="right" prop="备货建议" label="备货建议" width="110" sortable>
							<template slot-scope="scope">
								<div slot="reference" class="name-wrapper" style="padding-top: 5px;"
									v-if="scope.row.会员日备货 === 0 && scope.row.黑五备货 === 0 && scope.row.旺季备货 === 0 && scope.row.备货天数 === 0">
									{{ scope.row.备货建议 = 0 }}
								</div>
								<!-- 根据不同的建议方案计算 -->
								<div slot="reference" class="name-wrapper" style="padding-top: 5px;" v-else>
									{{ scope.row.备货建议 = calculateSuggestion(scope.row) }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="状态" label="状态" width="90" fixed="right">
							<template slot-scope="scope">
								<el-tag style=""
									:type="(scope.row.状态 == '正常' ? 'success' : (scope.row.状态 == '后补' ? 'danger' : (scope.row.状态 == '待淘汰-正常移入' || scope.row.状态 == '淘汰移出' ? 'warning' : 'info')))">
									{{ scope.row.状态 }}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column fixed="right" label="操作" width="184">
							<template slot-scope="scope">
								<el-dropdown @command="command => handleSelect_1(scope.row, command)">
									<el-button size="small" :loading="isSending4" plain
										style="float: right;margin-left: 3px;">编辑
									</el-button>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item command="编辑/详情">编辑/详情</el-dropdown-item>
										<el-dropdown-item command="正常">标记正常</el-dropdown-item>
										<el-dropdown-item command="后补">标记后补</el-dropdown-item>
										<el-dropdown-item command="待淘汰-正常移入">标记待淘汰-正常移入</el-dropdown-item>
										<el-dropdown-item command="淘汰移出">标记淘汰移出</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
								<el-button size="small" :loading="isSending5" plain
									style="float: right;margin-left: 3px;" v-if="scope.row.采购开关 === '不启用一键采购'"
									@click="caigou1(scope.row)">启动采购
								</el-button>
								<el-button size="small" :loading="isSending5" plain
									style="float: right;margin-left: 3px;" type="danger"
									v-else-if="scope.row.采购开关 === '启用一键采购'" @click="caigou2(scope.row)">关闭采购
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div>&nbsp;</div>
				<div style="width: 800px;">tip:备货天数常态为90天，当90天计算备货建议为正时则以120天计算;当70天安全库存大于70时会标黄;</div>
				<div style="width: 500px;color:red">采购流程: 输入指定采购数量-编辑选择SKU和FNSKU-点击启动采购-点击一键采购</div>

				<!-- <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;备货天数常态为90天，当备货建议为正时为120天</div> -->
			</div>
		</div>
		<el-dialog :title="title" :visible="dialogVisible1" width="750px" :before-close="handleClose1">
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left"
				:inline="true">
				<el-tooltip :content="'备货公式: ' + form.建议方案" placement="top">
					<el-switch v-model="form.建议方案" active-color="#13ce66" inactive-color="#ff4949"
						active-value="30天销量/30*（备货天数+旺季备货天数+黑五备货天数+会员日备货天数）-FBA库存-FBA在途-预计库存" active-text="建议方案二"
						inactive-text="建议方案一" inactive-value="30天销量/30*备货天数+旺季备货+黑五备货+会员日备货-FBA库存-FBA在途-预计库存">
					</el-switch>
				</el-tooltip>
			</el-form>
			<div>---</div>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left"
				:inline="true">
				<el-form-item label="会员日备货" prop="会员日备货" label-width="100px">
					<el-input v-model="form.会员日备货" placeholder="请输入会员日备货(只能填写数字)" style="width: 50%;" />
				</el-form-item>
				<el-form-item label="*会员日备货天数" prop="会员日备货天数" label-width="120px">
					<el-input v-model="form.会员日备货天数" placeholder="请输入会员日备货天数(只能填写数字)" style="width: 75%" />
				</el-form-item>
			</el-form>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="110px" label-position="left"
				:inline="true">
				<el-form-item label="黑五备货" prop="黑五备货" label-width="100px">
					<el-input v-model="form.黑五备货" placeholder="请输入黑五备货(只能填写数字)" style="width: 50%;" />
				</el-form-item>
				<el-form-item label="*黑五备货天数" prop="黑五备货天数" label-width="110px">
					<el-input v-model="form.黑五备货天数" placeholder="请输入黑五备货天数(只能填写数字)" style="width: 80%;" />
				</el-form-item>
			</el-form>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="110px" label-position="left"
				:inline="true">

				<el-form-item label="旺季备货" prop="旺季备货" label-width="100px">
					<el-input v-model="form.旺季备货" placeholder="请输入旺季备货(只能填写数字)" style="width: 50%;" />
				</el-form-item>
				<el-form-item label="*旺季备货天数" prop="旺季备货天数" label-width="110px">
					<el-input v-model="form.旺季备货天数" placeholder="请输入旺季备货天数(只能填写数字)" style="width: 80%;" />
				</el-form-item>
			</el-form>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left"
				:inline="true">
				<el-tooltip :content="'' + form.采购开关" placement="top">
					<el-switch v-model="form.采购开关" active-color="#13ce66" inactive-color="#ff4949" active-value="启用一键采购"
						inactive-text="采购开关" inactive-value="不启用一键采购">
					</el-switch>
				</el-tooltip>
			</el-form>
			<div>---</div>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="110px" label-position="left"
				:inline="true">
				<el-form-item label="SKU" prop="SKU">
					<el-select v-model="form.sku" clearable placeholder="请选择SKU" style="width: 60%;" filterable
						@visible-change="clearSelect" ref="skuSelect">
						<el-option v-for="item in sku" :key="item.value" :label="item.SKU" :value="item.value"
							autocomplete="off">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left"
				:inline="true">
				<el-tooltip :content="'' + form.是否使用新ASIN" placement="top">
					<el-switch v-model="form.是否使用新ASIN" active-color="#13ce66" inactive-color="#ff4949"
						active-value="工具自动生成新ASIN" inactive-text="是否使用新ASIN" inactive-value="工具使用目前选择FNSKU">
					</el-switch>
				</el-tooltip>
			</el-form>
			<div>---</div>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="110px" label-position="left"
				:inline="true" v-if="form.是否使用新ASIN === '工具使用目前选择FNSKU'">
				<el-alert title="提示：FNSKU显示为红色是45%佣金，绿色则是15%佣金，原色则是无数据" type="info" :closable="false" show-icon>
				</el-alert>
				<el-form-item label="FNSKU" prop="FNSKU" style="margin-top: 10px;">
					<el-select v-model="form.fnsku" clearable placeholder="请选择FNSKU" style="width: 70%;" filterable>
						<el-option v-for="item in fnsku" :key="item.value"
							:label="`${item.fnsku} (${item.value !== null && item.value !== undefined ? item.value.toFixed(2) : '无数据'})`"
							:value="item.fnsku" :style="getRateStyle(item.value)" autocomplete="off">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="仓库" prop="仓库" style="margin-top: 10px;">
					<el-select v-model="form.仓库" clearable placeholder="请选择仓库" style="width: 70%;" filterable>
						<el-option v-for="item in cangku" :key="item.value" :label="item.cangku" :value="item.value"
							autocomplete="off">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="110px" label-position="left"
				:inline="true" v-else-if="form.是否使用新ASIN === '工具自动生成新ASIN'">
				<el-form-item label="每个ASIN采购数量" prop="每个ASIN采购数量" label-width="130px">
					<el-input v-model="form.每个ASIN采购数量" placeholder="只能填写数字" style="width: 60%;" />
				</el-form-item>
				<el-form-item label="MSKU模版" prop="MSKU模版" label-width="100px">
					<el-input v-model="form.MSKU模版" placeholder="请输入MSKU模版" style="width: 80%;" />
				</el-form-item>
				<el-form-item label="供应商" prop="供应商" label-width="100px">
					<el-input v-model="form.供应商" placeholder="请输入供应商" style="width: 80%;" />
				</el-form-item>
				<el-form-item label="仓库" prop="仓库">
					<el-select v-model="form.仓库" clearable placeholder="请选择仓库" style="width: 70%;" filterable>
						<el-option v-for="item in cangku" :key="item.value" :label="item.cangku" :value="item.value"
							autocomplete="off">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="reset">重置</el-button>
				<el-button type="primary" @click="update_data" :loading="isSending2">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog :title="title" :visible="dialogVisible2" width="40%" :before-close="handleClose2">
			<el-form :model="form1" status-icon :rules="rules" ref="form1" label-width="100px" label-position="left"
				:inline="true">
				<el-tooltip :content="'备货公式: ' + form1.建议方案" placement="top">
					<el-switch v-model="form1.建议方案" active-color="#13ce66" inactive-color="#ff4949"
						active-value="30天销量/30*（备货天数+旺季备货天数+黑五备货天数+会员日备货天数）-FBA库存-FBA在途-预计库存" active-text="建议方案二"
						inactive-text="建议方案一" inactive-value="30天销量/30*备货天数+旺季备货+黑五备货+会员日备货-FBA库存-FBA在途-预计库存">
					</el-switch>
				</el-tooltip>
			</el-form>
			<div>---</div>
			<el-form :model="form1" status-icon :rules="rules" ref="form1" label-width="100px" label-position="left"
				:inline="true">
				<el-form-item label="会员日备货" prop="会员日备货" label-width="100px">
					<el-input v-model="form1.会员日备货" placeholder="请输入会员日备货(只能填写数字)" style="width: 70%;" />
				</el-form-item>
				<el-form-item label="*会员日备货天数" prop="会员日备货天数" label-width="120px">
					<el-input v-model="form1.会员日备货天数" placeholder="请输入会员日备货天数(只能填写数字)" style="width: 75%" />
				</el-form-item>
			</el-form>
			<el-form :model="form1" status-icon :rules="rules" ref="form1" label-width="110px" label-position="left"
				:inline="true">
				<el-form-item label="黑五备货" prop="黑五备货" label-width="100px">
					<el-input v-model="form1.黑五备货" placeholder="请输入黑五备货(只能填写数字)" style="width: 70%;" />
				</el-form-item>
				<el-form-item label="*黑五备货天数" prop="黑五备货天数" label-width="110px">
					<el-input v-model="form1.黑五备货天数" placeholder="请输入黑五备货天数(只能填写数字)" style="width: 80%;" />
				</el-form-item>
			</el-form>
			<el-form :model="form1" status-icon :rules="rules" ref="form1" label-width="110px" label-position="left"
				:inline="true">
				<el-form-item label="旺季备货" prop="旺季备货" label-width="100px">
					<el-input v-model="form1.旺季备货" placeholder="请输入旺季备货(只能填写数字)" style="width: 70%;" />
				</el-form-item>
				<el-form-item label="*旺季备货天数" prop="旺季备货天数" label-width="110px">
					<el-input v-model="form1.旺季备货天数" placeholder="请输入旺季备货天数(只能填写数字)" style="width: 80%;" />
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="reset">重置</el-button>
				<el-button type="primary" @click="updateall_data" :loading="isSending2">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog :title="title" :visible="dialogVisible_zd" width="30%" :before-close="handleClose_zd">
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left"
				:inline="true">
				<el-form-item label="指定采购数量" prop="指定采购数量" label-width="100px">
					<el-input v-model="form.指定采购数量" placeholder="请输入指定采购数量" style="width: 70%;" />
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="reset">重置</el-button>
				<el-button type="primary" @click="zhiding_update" :loading="isSending2">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			query: '',  // 本地父体搜索条件
			input: '',
			activeIndex: '1',
			activeIndex2: '1',
			bottercold: '',

			isSending_parent: false,
			isSending: false,
			isSending1: false,
			isSending2: false,
			isSending4: false,
			isSending5: false,
			isSending8: false,
			isSending18: false,
			isSending_in: false,
			isSending_register: false,
			dialogVisible: false,
			dialogVisible1: false,
			dialogVisible2: false,
			projectname: '',
			projectf: '',
			select_input: '',
			select_input2: "",
			isButtonDisabled: false,
			tableKey: 0,
			fileData: [],
			form: {},
			form1: {
				建议方案: '30天销量/30*备货天数+旺季备货+黑五备货+会员日备货-FBA库存-FBA在途-预计库存'
			},
			size: '',
			title: '',
			visible: false,
			tableData: [],
			tableData1: [],
			tableData2: [],
			tableData3: [],
			tableDataover: [],
			sku: [],
			fnsku: [],
			selectedDate: '',
			num1: 1,
			filters: [{ text: 'CoBak-US', value: 'CoBak-US' }, { text: 'CoBak-UK', value: 'CoBak-UK' }, { text: 'CoBak-SG', value: 'CoBak-SG' }, { text: 'CoBak-SE', value: 'CoBak-SE' }, { text: 'CoBak-PL', value: 'CoBak-PL' }, { text: 'CoBak-NL', value: 'CoBak-NL' }, { text: 'CoBak-MX', value: 'CoBak-MX' }, { text: 'CoBak-JP', value: 'CoBak-JP' }, { text: 'CoBak-IT', value: 'CoBak-IT' }, { text: 'CoBak-INDIA-IN', value: 'CoBak-INDIA-IN' }, { text: 'CoBak-FR', value: 'CoBak-FR' }, { text: 'CoBak-ES', value: 'CoBak-ES' }, { text: 'CoBak-DE', value: 'CoBak-DE' }, { text: 'CoBak-CA', value: 'CoBak-CA' }, { text: 'CoBak-BR', value: 'CoBak-BR' }, { text: 'CoBak Direct-BE', value: 'CoBak Direct-BE' }, { text: 'SMIFACE-CA', value: 'SMIFACE-CA' }, { text: 'SMIFACE-US', value: 'SMIFACE-US' }, { text: 'IDLEHANDS-US-CA', value: 'IDLEHANDS-US-CA' }, { text: 'iDLEHANDS-US-MX', value: 'iDLEHANDS-US-MX' }, { text: 'iDLEHANDS-US-US', value: 'iDLEHANDS-US-US' }, { text: 'European Union', value: 'EU' }],
			filterText: '',
			cangku: [{ text: '百汇办公室', value: '百汇办公室' }, { text: '工厂仓库', value: '工厂仓库' }, { text: '横中路仓库-加拿大', value: '横中路仓库-加拿大' }, { text: '横中路仓库-日本', value: '横中路仓库-日本' }, { text: '横中路仓库-美国', value: '横中路仓库-美国' }, { text: '横中路仓库-英国', value: '横中路仓库-英国' }, { text: '横中路仓库-德国', value: '横中路仓库-德国' }, { text: '淘汰-横中路成品仓库-加拿大', value: '淘汰-横中路成品仓库-加拿大' }, { text: '淘汰-横中路成品仓库-日本', value: '淘汰-横中路成品仓库-日本' }, { text: '淘汰-横中路成品仓库-美国', value: '淘汰-横中路成品仓库-美国' }, { text: '淘汰-横中路成品仓库-英国', value: '淘汰-横中路成品仓库-英国' }, { text: '批发仓库', value: '批发仓库' }, { text: '横中路仓库-印度', value: '横中路仓库-印度' }, { text: '横中路仓库-公共', value: '横中路仓库-公共' }],
			value: '',
			visible1: false,
			value1: [],
			value2: [],
			value3: [],
			test: [],
			formLabelWidth: '80px',
			timer: null,
			named: '',
			fand: 0,
			store: [],
			flagnum: 0,
		}
	},
	methods: {

		clearSelect(changed) {
			// 1. 清空已选择的值

			if (changed) {
				this.sku = []
				this.select_sku(this.title)
			}
			else {
				this.sku = [];
			}



		},

		sortBy30Days(a, b) {
			// a和b是表格中的两行数据
			// 升序：a - b；降序：b - a（方法内部会根据点击自动切换）
			return a.三十天销量 - b.三十天销量;
		},






		getRowStyle(row) {
			if (this.calculateSafetyStock(row.row) < 70) {
				return { backgroundColor: '#FFF9C4' };
			}
			return {};
		},
		calculateSafetyStock(row) {
			if (!row['三十天销量'] || row['三十天销量'] === 0) return 0;
			const safetyStock = (row['FBA库存'] + row['FBA在途']) / row['三十天销量'] * 30;
			return Math.round(safetyStock); // 保留两位小数
		},
		handleSelect_1(row, command) {
			console.log('选中行内容:', row);
			console.log('选中选项:', command);
			if (command == '编辑/详情') {
				this.update(row)
			} else if (command == '指定采购数量') {
				this.zhiding(row)
			} else {
				this.test = []
				this.test = row
				this.update_state_1(row, command)
			}
		},
		getRateStyle(value) {
			if (value === null || value === undefined || value === 0) {
				return {};
			}

			if (value > 0.3) {
				return { color: '#f56c6c' }; // 红色
			} else if (value > 0.1 && value <= 0.3) {
				return { color: '#67c23a' }; // 绿色
			}

			return {}; // 默认颜色
		},
		update_state_1(row, state) {
			this.test.状态 = state
			this.$axios.post('/vue/parent_calculate/update_state_1', { row: row, state: state }).then(res => {
				console.log(res);
				if (res.code == 200) {
					let _this = this
					this.$notify.success({
						title: '更改成功',
						message: res.msg,
						duration: 2000,
						onClose: function () { _this.handleClose2() }
					});
				} else {
					this.$notify.error({
						title: '错误',
						message: res.msg,
						duration: 20000
					});
				}
			}).catch(error => {
				console.log(error)
			})
		},
		doubleClickCell(row) {
			this.$set(row, "edit", true)
		},
		levelChange(row) {
			this.$set(row, "edit", false)
			this.$axios.post('/vue/parent_calculate/zhiding_update', row).then(res => {
				if (res.code == 200) {
					let _this = this
					this.$notify.success({
						title: '更改成功',
						message: res.msg,
						duration: 2000,
						onClose: function () { _this.handleClose_zd() }
					});
				} else {
					this.$notify.error({
						title: '错误',
						message: res.msg,
						duration: 2000
					});
				}
			})
				.catch(error => {
					console.log(error)
				})
		},
		open(male_parent) {
			this.$confirm('此操作将收藏该本地父体, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$message({
					type: 'success',
					message: '收藏成功!'
				})
				this.$axios.post('/vue/parent_calculate/menu_collect', { male_parent: male_parent }).then(res => {
					console.log(res)
					this.init()
				}).catch(error => {
					console.log(error)
					alert('发生错误:==' + error)
				})
			}).catch(() => {
				// 用户点击取消时的处理（防止报 Uncaught）
				this.$message({
					type: 'info',
					message: '已取消操作'
				})
			})
		},
		open1(male_parent) {
			this.$confirm('此操作将取消收藏该本地父体, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$message({
					type: 'success',
					message: '取消收藏成功!'
				})
				this.$axios.post('/vue/parent_calculate/menu_unbind', { male_parent: male_parent }).then(res => {
					console.log(res)
					this.init()
				}).catch(error => {
					console.log(error)
					alert('发生错误:==' + error)
				})
			}).catch(() => {
				// 用户点击取消时的处理（防止报 Uncaught）
				this.$message({
					type: 'info',
					message: '已取消操作'
				})
			})
		},
		isInSeason(type) {
			const today = new Date();
			const year = today.getFullYear();
			let startDate, endDate;
			if (type === '旺季') {
				startDate = new Date(`${year}-07-30`)
				endDate = new Date(`${year}-11-30`)
			} else if (type === '黑五') {
				startDate = new Date(`${year}-07-30`)
				endDate = new Date(`${year}-11-30`)
			} else if (type === '会员日') {
				const startDate1 = new Date(`${year}-04-15`)
				const endDate1 = new Date(`${year}-07-15`)
				const startDate2 = new Date(`${year}-07-30`)
				const endDate2 = new Date(`${year}-10-15`)
				return (today >= startDate1 && today <= endDate1) || (today >= startDate2 && today <= endDate2);
			}
			return today >= startDate && today <= endDate;
		},
		calculateSuggestion(row) {
			let baseDays = row.备货天数;  // 默认使用备货天数
			// 根据不同的建议方案计算备货建议
			let suggestion;
			if (row.建议方案 === '30天销量/30*备货天数+旺季备货+黑五备货+会员日备货-FBA库存-FBA在途-预计库存') {
				suggestion = Math.round(
					Number(row.三十天销量) / 30 * baseDays
					+ (this.isInSeason('旺季') ? Number(row.旺季备货) : 0)
					+ (this.isInSeason('黑五') ? Number(row.黑五备货) : 0)
					+ (this.isInSeason('会员日') ? Number(row.会员日备货) : 0)
					- Number(row.FBA库存)
					- Number(row.FBA在途)
					- Number(row.预计库存)
				);
				// 如果备货建议为正数，将备货天数设为 120，并重新计算
				if (suggestion > 0) {
					baseDays = 120;
					suggestion = Math.round(
						Number(row.三十天销量) / 30 * baseDays
						+ (this.isInSeason('旺季') ? Number(row.旺季备货) : 0)
						+ (this.isInSeason('黑五') ? Number(row.黑五备货) : 0)
						+ (this.isInSeason('会员日') ? Number(row.会员日备货) : 0)
						- Number(row.FBA库存)
						- Number(row.FBA在途)
						- Number(row.预计库存)
					);
				}
				return suggestion;
			} else if (row.建议方案 === '30天销量/30*（备货天数+旺季备货天数+黑五备货天数+会员日备货天数）-FBA库存-FBA在途-预计库存') {
				suggestion = Math.round(
					Number(row.三十天销量) / 30 *
					(baseDays +
						(this.isInSeason('旺季') ? Number(row.旺季备货天数) : 0) +
						(this.isInSeason('黑五') ? Number(row.黑五备货天数) : 0) +
						(this.isInSeason('会员日') ? Number(row.会员日备货天数) : 0))
					- Number(row.FBA库存)
					- Number(row.FBA在途)
					- Number(row.预计库存)
				);
				// 如果备货建议为正数，将备货天数设为 120，并重新计算
				if (suggestion > 0) {
					baseDays = 120;
					suggestion = Math.round(
						Number(row.三十天销量) / 30 *
						(baseDays +
							(this.isInSeason('旺季') ? Number(row.旺季备货天数) : 0) +
							(this.isInSeason('黑五') ? Number(row.黑五备货天数) : 0) +
							(this.isInSeason('会员日') ? Number(row.会员日备货天数) : 0))
						- Number(row.FBA库存)
						- Number(row.FBA在途)
						- Number(row.预计库存)
					);
				}
				return suggestion;
			}
		},
		init() {
			this.isSending = true
			let params = {
				query: this.query
			}
			this.$axios.get('/vue/auto_update/seller_asin_select', { params }).then(res => {
				console.log(res);
				if (res.msg == 'success') {
					this.tableData = res.data
					this.isSending = false
				} else {
					alert(res.message)
					this.isSending = false
				}
			}).catch(error => {
				console.log(error)
				alert('发生错误:==' + error)
			})
		},

		check_care_parent() {
			this.isSending_parent = true
			let params = {
				query: this.query
			}
			this.$axios.get('/vue/auto_update/seller_asin_care_select', { params }).then(res => {
				console.log(res);
				if (res.msg == 'success') {
					this.tableData = res.data
					this.isSending_parent = false
				} else {
					alert(res.message)
					this.isSending_parent = false
				}
			}).catch(error => {
				console.log(error)
				alert('发生错误:==' + error)
			})
		},



		select_sku(pm) {
			this.sku = []
			this.$axios.post('/vue/parent_calculate/select_sku', { pm: pm }).then(res => {
				if (res.msg == 'success') {
					this.sku = res.data
				} else {
					console.log(res.data)
				}
			}).catch(error => {
				console.log(error)
				alert('发生错误:==' + error)
			})
		},
		handleSelect(key, keyPath) {
			console.log(key, keyPath);
		},
		update(row) {
			this.title = row.本地品名
			this.form = {}
			this.form = row
			this.dialogVisible1 = true
			this.select_fnsku(row.本地品名, this.filterText)
		},
		zhiding(row) {
			this.title = row.本地品名
			this.form = {}
			this.fnsku = {}
			this.sku = {}
			this.form = row
			this.dialogVisible_zd = true
		},
		select_fnsku(pm, shop) {
			// 如果选择的是欧盟店铺，则实际使用德国店铺查询
			const actualShop = shop === 'EU' ? 'CoBak-DE' : shop;
			this.$axios.post('/vue/parent_calculate/select_fnsku', { pm: pm, shop: actualShop })
				.then(res => {
					if (res.msg == 'success') {
						this.fnsku = res.data
						this.dialogVisible1 = true;
						console.log('点击编辑窗口弹出得fnsku有这些', this.fnsku)
					} else {
						console.log(res.data)
					}
					this.select_sku(pm)
				}).catch(error => {
					console.log(error)
					alert('发生错误: ' + error.message)
				})
		},
		auto_caigou() {
			this.isSending18 = true
			this.$axios.post('/vue/parent_calculate/auto_caigou', this.tableData3).then(res => {
				if (res.msg == 'success') {
					alert(res.data)
					this.isSending18 = false
				} else {
					alert('发生错误:==' + res.data)
					this.isSending18 = false
				}
			}).catch(error => {
				console.log(error)
				alert('发生错误:==' + error)
				this.isSending18 = false
			})
		},
		handlePreview(file) {
			console.log(file);
		},
		handleClose() {
			this.dialogVisible = false
			this.init()
		},
		handleClose1() {
			this.dialogVisible1 = false
			this.jojo1(this.form.本地父体)
		},
		handleClose2() {
			this.dialogVisible2 = false
			this.jojo1(this.projectf)
		},
		handleClose_zd() {
			this.dialogVisible_zd = false
		},
		reset() {
			let id = undefined
			if ('id' in this.form) {
				id = this.form.id
			}
			this.form = {}
			if (id != undefined) this.form.id = id
		},
		jojo(project) {
			if (this.filterText == '') {
				alert('请选择店铺')
			} else {
				this.$axios.post('/vue/parent_calculate/parent_select_child', { name: project, shop: this.filterText }).then(res => {
					console.log(res);
					if (res.msg == 'success') {
						this.tableData1 = res.data
						this.projectf = project
						// this.applySorting(); // 应用排序
					} else {
						alert('未获取到该父体的品名数据')
					}
				}).catch(error => {
					console.log(error)
					alert('发生错误:==' + error)
				})
			}
		},
		jojo1(project) {
			if (this.filterText == '') {
				alert('请选择店铺')
			} else {
				this.$axios.post('/vue/parent_calculate/parent_select_child', { name: project, shop: this.filterText }).then(res => {
					console.log(res);
					if (res.msg == 'success') {
						this.projectf = project
						// this.applySorting(); // 应用排序
					} else {
						alert('未获取到该父体的品名数据')
					}
				}).catch(error => {
					console.log(error)
					alert('发生错误:==' + error)
				})
			}
		},
		jojo2() {
			if (this.filterText == '') {
				alert('请选择店铺')
			} else {
				this.$axios.post('/vue/parent_calculate/parent_select_child', { name: this.projectf, shop: this.filterText }).then(res => {
					console.log(res);
					if (res.msg == 'success') {
						this.tableData3 = res.data
						this.auto_caigou()
						// this.applySorting(); // 应用排序
					} else {
						alert('未获取到该父体的品名数据')
					}
				}).catch(error => {
					console.log(error)
					alert('发生错误:==' + error)
				})
			}
		},
		caigou1(row) {
			if (row.sku == '') {
				alert('请先选择sku')
			} else if (row.是否使用新ASIN == '工具使用目前选择FNSKU') {
				if (row.fnsku == '' || row.仓库 == '') {
					alert('请检查fnsku/仓库是否已选择')
				} else {
					this.caigou11(row)
				}
			} else if (row.是否使用新ASIN == '工具自动生成新ASIN') {
				if (row.每个ASIN采购数量 == 0 || row.MSKU模版 == '' || row.供应商 == '' || row.仓库 == '') {
					alert('请检查每个ASIN采购数量/MSKU模版/供应商/仓库是否填写完整')
				} else {
					this.caigou11(row)
				}
			}
		},
		caigou11(row) {
			this.isSending5 = true
			this.test = []
			this.test = row
			this.$axios.post('/vue/parent_calculate/caigou1', row).then(res => {
				if (res.code == 200) {
					let _this = this
					this.$notify.success({
						title: '成功',
						message: res.msg,
						duration: 2000,
						onClose: function () { _this.handleClose2() }
					});
					this.test.采购开关 = '启用一键采购'
					this.isSending5 = false
				} else {
					this.$notify.error({
						title: '错误',
						message: res.msg,
						duration: 2000
					});
					this.isSending5 = false
				}
			})
				.catch(error => {
					console.log(error)
					alert('发生错误:==' + error)
					this.isSending5 = false
				})
		},
		caigou2(row) {
			if (row.sku == '') {
				alert('请先选择sku')
			} else {
				this.isSending5 = true
				this.test = []
				this.test = row
				this.$axios.post('/vue/parent_calculate/caigou2', row).then(res => {
					if (res.code == 200) {
						let _this = this
						this.$notify.success({
							title: '成功',
							message: res.msg,
							duration: 2000,
							onClose: function () { _this.handleClose2() }
						});
						this.test.采购开关 = '不启用一键采购'
						this.isSending5 = false
					} else {
						this.$notify.error({
							title: '错误',
							message: res.msg,
							duration: 2000
						});
						this.isSending5 = false
					}
				})
					.catch(error => {
						console.log(error)
						alert('发生错误:==' + error)
						this.isSending5 = false
					})
			}
		},
		allupdate() {
			if (this.filterText != '' && this.projectf != '') {
				this.title = '批量编辑'
				this.dialogVisible2 = true
			} else {
				alert('请先选择父体和店铺')
			}
		},
		update_data() {
			if (this.form.MSKU模版.length > 23) {
				alert('MSKU模版字数超过23，请修改后再提交')
			} else if (this.form.采购开关 == '启用一键采购') {
				if (this.form.sku == '') {
					alert('请先选择sku')
				} else if (this.form.是否使用新ASIN == '工具使用目前选择FNSKU') {
					if (this.form.fnsku == '' || this.form.仓库 == '') {
						alert('请检查fnsku/仓库是否已选择')
					} else {
						this.isSending2 = true
						console.log(this.form);
						this.$axios.post('/vue/parent_calculate/update_data', this.form).then(res => {
							if (res.code == 200) {
								let _this = this
								this.$notify.success({
									title: '成功',
									message: res.msg,
									duration: 2000,
									onClose: function () { _this.handleClose1() }
								});
								this.isSending2 = false
							} else {
								this.$notify.error({
									title: '错误',
									message: res.msg,
									duration: 2000
								});
								this.isSending2 = false
							}
						})
							.catch(error => {
								console.log(error)
								alert('发生错误:==' + '请检查内容是否填写完整')
								this.isSending2 = false
							})
					}
				} else if (this.form.是否使用新ASIN == '工具自动生成新ASIN') {
					if (this.form.每个ASIN采购数量 == 0 || this.form.MSKU模版 == '' || this.form.供应商 == '' || this.form.仓库 == '') {
						alert('请检查每个ASIN采购数量/MSKU模版/供应商/仓库是否填写完整')
					} else {
						this.isSending2 = true
						console.log(this.form);
						this.$axios.post('/vue/parent_calculate/update_data', this.form).then(res => {
							if (res.code == 200) {
								let _this = this
								this.$notify.success({
									title: '成功',
									message: res.msg,
									duration: 2000,
									onClose: function () { _this.handleClose1() }
								});
								this.isSending2 = false
							} else {
								this.$notify.error({
									title: '错误',
									message: res.msg,
									duration: 2000
								});
								this.isSending2 = false
							}
						})
							.catch(error => {
								console.log(error)
								alert('发生错误:==' + '请检查内容是否填写完整')
								this.isSending2 = false
							})
					}
				}
			} else {
				this.isSending2 = true
				console.log(this.form);
				this.$axios.post('/vue/parent_calculate/update_data', this.form).then(res => {
					if (res.code == 200) {
						let _this = this
						this.$notify.success({
							title: '成功',
							message: res.msg,
							duration: 2000,
							onClose: function () { _this.handleClose1() }
						});
						this.isSending2 = false
					} else {
						this.$notify.error({
							title: '错误',
							message: res.msg,
							duration: 2000
						});
						this.isSending2 = false
					}
				})
					.catch(error => {
						console.log(error)
						alert('发生错误:==' + '请检查内容是否填写完整')
						this.isSending2 = false
					})
			}
		},
		change_all() {
			if (this.projectf == '') {
				alert('请先选择父体')
			} else {
				this.$confirm('是否要将备货建议全部填入指定采购数量', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '置换成功!'
					})
					this.$axios.post(`/vue/parent_calculate/change_all`, this.tableData1).then(res => {
						console.log(res)
						if (res.msg == 'success') {
							this.jojo(this.projectf)
						}
						// this.applySorting(); // 应用排序
					}).catch(error => {
						console.log(error)
					})
				})
			}
		},
		updateall_data() {
			this.isSending2 = true
			console.log(this.form1);
			this.$axios.post('/vue/parent_calculate/update_alldata', { form: this.form1, data: this.tableData1 }).then(res => {
				if (res.code == 200) {
					let _this = this
					this.$notify.success({
						title: '成功',
						message: res.msg,
						duration: 2000,
						onClose: function () { _this.handleClose2() }
					});
					this.isSending2 = false
				} else {
					this.$notify.error({
						title: '错误',
						message: res.msg,
						duration: 2000
					});
					this.isSending2 = false
				}
			})
				.catch(error => {
					console.log(error)
					alert('发生错误:==' + '请检查内容是否填写完整')
					this.isSending2 = false
				})
		},
		zhiding_update() {
			this.isSending2 = true
			this.$axios.post('/vue/parent_calculate/zhiding_update', this.form).then(res => {
				if (res.code == 200) {
					let _this = this
					this.$notify.success({
						title: '更改成功',
						message: res.msg,
						duration: 2000,
						onClose: function () { _this.handleClose_zd() }
					});
					this.isSending2 = false
				} else {
					this.$notify.error({
						title: '错误',
						message: res.msg,
						duration: 2000
					});
					this.isSending2 = false
				}
			})
				.catch(error => {
					console.log(error)
					alert('发生错误:==' + '请检查内容是否填写完整')
					this.isSending2 = false
				})
		},
		select_pm() {
			if (this.filterText == '') {
				alert('请选择店铺')
			} else {
				this.isSending8 = true
				this.$axios.post(`/vue/parent_calculate/select_pm`, { input: this.select_input, input2: this.select_input2, shop: this.filterText }).then(res => {
					console.log(res)
					this.tableData1 = res.data
					// this.applySorting(); // 应用排序
					this.isSending8 = false
				}).catch(error => {
					alert(error)
					console.log(error)
					this.isSending8 = false
				})
			}
		},
	},
}
</script>

<style>
.main {
	height: 100%;
	width: 100%;
}

.select_menu {
	width: 100%;
	height: 4.5%;
	background-color: rgb(250, 250, 250);
}

.parent_calculate {
	/* border: 1px solid red; */
	height: 88.9%;
}

.parent_calculate_div1 {
	width: 14.2%;
	height: 94%;
	margin: 20px;
	float: left;
}

.parent_calculate_div3 {
	width: 23%;
	height: 94%;
	margin: 20px;
	float: left;

}

.parent_calculate_table1 {
	width: 100%;
	border: 2px solid rgb(207, 207, 207);
	height: 92%;
	margin-top: 10px;

}

.parent_calculate_table2 {
	overflow-x: auto;
	width: 580%;
	border: 2px solid rgb(207, 207, 207);
	height: 92%;
	margin-top: 10px;

}

.parent_calculate_table3 {
	width: 800px;
	border: 2px solid rgb(207, 207, 207);
	height: 92%;
	margin-top: 47px;
	margin-left: 48%;

}

.green-color {
	color: green;
}

.yellow-color {
	color: rgb(192, 192, 84);
}

.demo-table-expand {
	font-size: 0;
}

.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}

.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 100%;
}
</style>

<style scoped="scoped">
.purchase-wrapper {
	padding: 5px 0;
	text-align: right;
	/* 右对齐，与固定列右侧对齐 */
	line-height: 1.5;
}

/* 单个数量项 */
.purchase-item {
	font-size: 13px;
	display: inline-block;
	width: 100%;
}

/* 标签样式（灰色小字） */
.label {
	color: #909399;
	margin-right: 4px;
}

/* 数值样式（深色突出） */
.value {
	color: #303133;
	font-weight: 500;
}

/* 上下项分隔 */
.purchase-item:first-child {
	margin-bottom: 3px;
}

.input-label {
	margin-left: 17px;
	margin-right: -25px;

}



.sales-wrapper {
	padding: 5px 0;
	line-height: 1.5;
	/* 调整行高，避免拥挤 */
}

/* 单个销量项样式 */
.sales-item {
	font-size: 13px;
	/* 适当缩小字体，节省空间 */
	color: #606266;
	/* 统一文字颜色 */
}

/* 可添加分隔线增强可读性 */
.sales-item:not(:last-child) {
	border-bottom: 1px dashed #eee;
	margin-bottom: 3px;
	padding-bottom: 3px;
}

::v-deep .warm tbody tr>td {
	background-color: rgba(236, 236, 236, 0.8);
}

::v-deep .el-table__body-wrapper {
	z-index: 1
}
</style>